import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2ProviderEligibilityBatch: build.mutation<
      PostV2ProviderEligibilityBatchApiResponse,
      PostV2ProviderEligibilityBatchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/eligibility/batch`,
        method: "POST",
        body: queryArg.batchCheckRequest,
      }),
    }),
    getV2ProviderEligibilityBatchByBatchId: build.query<
      GetV2ProviderEligibilityBatchByBatchIdApiResponse,
      GetV2ProviderEligibilityBatchByBatchIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/eligibility/batch/${queryArg.batchId}`,
      }),
    }),
    postV2ProviderEligibilityChecksBatch: build.mutation<
      PostV2ProviderEligibilityChecksBatchApiResponse,
      PostV2ProviderEligibilityChecksBatchApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/eligibility/checks/batch`,
        method: "POST",
        body: queryArg.bulkCheckRequest,
      }),
    }),
    getV2ProviderEligibilityWorklist: build.query<
      GetV2ProviderEligibilityWorklistApiResponse,
      GetV2ProviderEligibilityWorklistApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/eligibility/worklist`,
        params: {
          days: queryArg.days,
          include_silenced: queryArg.includeSilenced,
          segment: queryArg.segment,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderEncountersByEncounterIdEligibility: build.query<
      GetV2ProviderEncountersByEncounterIdEligibilityApiResponse,
      GetV2ProviderEncountersByEncounterIdEligibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/eligibility`,
      }),
    }),
    postV2ProviderEncountersByEncounterIdEligibility: build.mutation<
      PostV2ProviderEncountersByEncounterIdEligibilityApiResponse,
      PostV2ProviderEncountersByEncounterIdEligibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/eligibility`,
        method: "POST",
      }),
    }),
    postV2ProviderEncountersByEncounterIdEligibilityVerifications:
      build.mutation<
        PostV2ProviderEncountersByEncounterIdEligibilityVerificationsApiResponse,
        PostV2ProviderEncountersByEncounterIdEligibilityVerificationsApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/encounters/${queryArg.encounterId}/eligibility/verifications`,
          method: "POST",
          body: queryArg.manualUpdateRequest,
        }),
      }),
    getV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibility:
      build.query<
        GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityApiResponse,
        GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/coverages/${queryArg.coverageId}/eligibility`,
        }),
      }),
    postV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityCheck:
      build.mutation<
        PostV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityCheckApiResponse,
        PostV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityCheckApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/coverages/${queryArg.coverageId}/eligibility/check`,
          method: "POST",
          body: queryArg.eligibilityCheckRequest,
        }),
      }),
    getV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityHistory:
      build.query<
        GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityHistoryApiResponse,
        GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/coverages/${queryArg.coverageId}/eligibility/history`,
        }),
      }),
    postV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityManual:
      build.mutation<
        PostV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityManualApiResponse,
        PostV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityManualApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/coverages/${queryArg.coverageId}/eligibility/manual`,
          method: "POST",
          body: queryArg.eligibilityManualRequest,
        }),
      }),
    getV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityPayerHistory:
      build.query<
        GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityPayerHistoryApiResponse,
        GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityPayerHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/coverages/${queryArg.coverageId}/eligibility/payer-history`,
          params: {
            limit: queryArg.limit,
          },
        }),
      }),
    getV2ProviderPatientsByPatientIdEligibility: build.query<
      GetV2ProviderPatientsByPatientIdEligibilityApiResponse,
      GetV2ProviderPatientsByPatientIdEligibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/eligibility`,
      }),
    }),
    postV2ProviderPatientsByPatientIdEligibility: build.mutation<
      PostV2ProviderPatientsByPatientIdEligibilityApiResponse,
      PostV2ProviderPatientsByPatientIdEligibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/eligibility`,
        method: "POST",
      }),
    }),
    deleteV2ProviderPatientsByPatientIdEligibilityDisposition: build.mutation<
      DeleteV2ProviderPatientsByPatientIdEligibilityDispositionApiResponse,
      DeleteV2ProviderPatientsByPatientIdEligibilityDispositionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/eligibility/disposition`,
        method: "DELETE",
      }),
    }),
    postV2ProviderPatientsByPatientIdEligibilityDispositionDismiss:
      build.mutation<
        PostV2ProviderPatientsByPatientIdEligibilityDispositionDismissApiResponse,
        PostV2ProviderPatientsByPatientIdEligibilityDispositionDismissApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/eligibility/disposition/dismiss`,
          method: "POST",
        }),
      }),
    postV2ProviderPatientsByPatientIdEligibilityDispositionSnooze:
      build.mutation<
        PostV2ProviderPatientsByPatientIdEligibilityDispositionSnoozeApiResponse,
        PostV2ProviderPatientsByPatientIdEligibilityDispositionSnoozeApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/patients/${queryArg.patientId}/eligibility/disposition/snooze`,
          method: "POST",
          body: queryArg.snoozeAlertsRequest,
        }),
      }),
    getV2ProviderPatientsByPatientIdEligibilityVerifications: build.query<
      GetV2ProviderPatientsByPatientIdEligibilityVerificationsApiResponse,
      GetV2ProviderPatientsByPatientIdEligibilityVerificationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/eligibility/verifications`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    postV2ProviderPatientsByPatientIdEligibilityVerifications: build.mutation<
      PostV2ProviderPatientsByPatientIdEligibilityVerificationsApiResponse,
      PostV2ProviderPatientsByPatientIdEligibilityVerificationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/eligibility/verifications`,
        method: "POST",
        body: queryArg.manualUpdateRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2ProviderEligibilityBatchApiResponse =
  /** status 200 OK */ BatchCheckResponse;
export type PostV2ProviderEligibilityBatchApiArg = {
  batchCheckRequest: BatchCheckRequest;
};
export type GetV2ProviderEligibilityBatchByBatchIdApiResponse =
  /** status 200 OK */ EligibilityBatchProgressResponse;
export type GetV2ProviderEligibilityBatchByBatchIdApiArg = {
  batchId: string;
};
export type PostV2ProviderEligibilityChecksBatchApiResponse =
  /** status 200 OK */ BulkCheckResponse;
export type PostV2ProviderEligibilityChecksBatchApiArg = {
  bulkCheckRequest: BulkCheckRequest;
};
export type GetV2ProviderEligibilityWorklistApiResponse =
  /** status 200 OK */ WorklistResponse;
export type GetV2ProviderEligibilityWorklistApiArg = {
  days?: number;
  includeSilenced?: boolean;
  /** Filter items to a single segment bucket. ``silenced`` requires ``include_silenced=true``. Invalid values return 422. */
  segment?:
    | (
        | "all"
        | "needs_now"
        | "collect"
        | "needs_coverage"
        | "awaiting_check"
        | "info"
        | "verified"
        | "silenced"
      )
    | null;
  page?: number;
  perPage?: number;
};
export type GetV2ProviderEncountersByEncounterIdEligibilityApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type GetV2ProviderEncountersByEncounterIdEligibilityApiArg = {
  encounterId: string;
};
export type PostV2ProviderEncountersByEncounterIdEligibilityApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type PostV2ProviderEncountersByEncounterIdEligibilityApiArg = {
  encounterId: string;
};
export type PostV2ProviderEncountersByEncounterIdEligibilityVerificationsApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type PostV2ProviderEncountersByEncounterIdEligibilityVerificationsApiArg =
  {
    encounterId: string;
    manualUpdateRequest: ManualUpdateRequest;
  };
export type GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityApiResponse =
  /** status 200 OK */ EligibilityCurrentResponse;
export type GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityApiArg =
  {
    patientId: string;
    coverageId: string;
  };
export type PostV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityCheckApiResponse =
  /** status 200 OK */ EligibilityCommandResponse;
export type PostV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityCheckApiArg =
  {
    patientId: string;
    coverageId: string;
    eligibilityCheckRequest: EligibilityCheckRequest;
  };
export type GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityHistoryApiResponse =
  /** status 200 OK */ EligibilityHistoryResponse;
export type GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityHistoryApiArg =
  {
    patientId: string;
    coverageId: string;
  };
export type PostV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityManualApiResponse =
  /** status 200 OK */ EligibilityCommandResponse;
export type PostV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityManualApiArg =
  {
    patientId: string;
    coverageId: string;
    eligibilityManualRequest: EligibilityManualRequest;
  };
export type GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityPayerHistoryApiResponse =
  /** status 200 OK */ PayerHistoryResponse;
export type GetV2ProviderPatientsByPatientIdCoveragesAndCoverageIdEligibilityPayerHistoryApiArg =
  {
    patientId: string;
    coverageId: string;
    /** Maximum claims, each with up to five payer reports. Newest service dates first; truncated signals omitted claims, reports, or service lines. */
    limit?: number;
  };
export type GetV2ProviderPatientsByPatientIdEligibilityApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type GetV2ProviderPatientsByPatientIdEligibilityApiArg = {
  patientId: string;
};
export type PostV2ProviderPatientsByPatientIdEligibilityApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type PostV2ProviderPatientsByPatientIdEligibilityApiArg = {
  patientId: string;
};
export type DeleteV2ProviderPatientsByPatientIdEligibilityDispositionApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type DeleteV2ProviderPatientsByPatientIdEligibilityDispositionApiArg = {
  patientId: string;
};
export type PostV2ProviderPatientsByPatientIdEligibilityDispositionDismissApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type PostV2ProviderPatientsByPatientIdEligibilityDispositionDismissApiArg =
  {
    patientId: string;
  };
export type PostV2ProviderPatientsByPatientIdEligibilityDispositionSnoozeApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type PostV2ProviderPatientsByPatientIdEligibilityDispositionSnoozeApiArg =
  {
    patientId: string;
    snoozeAlertsRequest: SnoozeAlertsRequest;
  };
export type GetV2ProviderPatientsByPatientIdEligibilityVerificationsApiResponse =
  /** status 200 OK */ ListResponseVerificationEventResponse;
export type GetV2ProviderPatientsByPatientIdEligibilityVerificationsApiArg = {
  patientId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
};
export type PostV2ProviderPatientsByPatientIdEligibilityVerificationsApiResponse =
  /** status 200 OK */ EligibilityCheckResponse;
export type PostV2ProviderPatientsByPatientIdEligibilityVerificationsApiArg = {
  patientId: string;
  manualUpdateRequest: ManualUpdateRequest;
};
export type BatchCheckResponse = {
  actions_created: number;
  batch_id: string;
  discovery_actions_created?: number;
  estimated_completion_minutes: number;
  skipped_recently_checked: number;
  total_patients: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type BatchCheckRequest = {
  /** Number of days ahead to look for appointments */
  days_ahead?: number;
  /** Skip patients checked within this many hours */
  staleness_hours?: number;
};
export type EligibilityBatchProgressResponse = {
  batch_id: string;
  completed: number;
  failed: number;
  pending: number;
  progress_pct: number;
  total: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type BulkCheckResultItem = {
  /** Set when status is success or deduped — points the FE at the snapshot it should refetch / display. */
  eligibility_snapshot_id?: string | null;
  encounter_id?: string | null;
  error_code?: string | null;
  error_message?: string | null;
  patient_id: string;
  /** Effective readiness on the resulting snapshot, when available. Lets the FE update the row badge in place without an extra lookup. */
  readiness?:
    | ("verified" | "collect" | "collected" | "attention" | "blocked" | "info")
    | null;
  status:
    | "success"
    | "deduped"
    | "self_pay_skipped"
    | "member_id_missing"
    | "failed";
};
export type BulkCheckSummary = {
  deduped: number;
  failed: number;
  member_id_missing?: number;
  self_pay_skipped: number;
  succeeded: number;
  total: number;
};
export type BulkCheckResponse = {
  results: BulkCheckResultItem[];
  summary: BulkCheckSummary;
};
export type BulkCheckTarget = {
  /** When provided, the snapshot is encounter-scoped — used by the worklist's per-row Run button. Omit for a patient-level check. */
  encounter_id?: string | null;
  /** Patient to check. */
  patient_id: string;
};
export type BulkCheckRequest = {
  /** When true, bypass the per-target dedup window and re-run even if a snapshot was just created. Use sparingly — most callers want default dedup so double-clicks don't double-bill. */
  force?: boolean;
  /** Up to 25 targets per call. Larger volumes should split across multiple requests or move to the async scheduled batch. */
  targets: BulkCheckTarget[];
};
export type FixedCopayCollection = {
  amount_cents: number;
  kind: "fixed_copay";
};
export type PatientCostSource = {
  confirmed_at: string;
  id: string;
  kind: "visit_amount_confirmation" | "final_claim_pr";
  revision: string;
};
export type PatientCostVisitContext = {
  appointment_id?: string | null;
  coverage_id: string;
  encounter_id?: string | null;
  service_date: string;
};
export type ConfirmedPatientCost = {
  amount_cents: number;
  amount_status?: "confirmed";
  coinsurance_percent?: number | null;
  collection?: FixedCopayCollection | null;
  copayment_cents?: number | null;
  coverage_id: string;
  policy_version?: "fixed-copay-v2";
  record_revision?: number | null;
  source: PatientCostSource;
  visit_context: PatientCostVisitContext;
};
export type UndeterminedPatientCost = {
  amount_cents?: null;
  amount_status?: "undetermined";
  coinsurance_percent?: number | null;
  collection?: FixedCopayCollection | null;
  copayment_cents?: number | null;
  coverage_id?: string | null;
  policy_version?: "fixed-copay-v2";
  reason:
    | "coinsurance_requires_allowed_amount"
    | "mixed_cost_sharing"
    | "deductible_applies"
    | "benefits_incomplete"
    | "visit_context_missing"
    | "source_unavailable";
  record_revision?: number | null;
  source?: null;
  visit_context?: PatientCostVisitContext | null;
};
export type WorklistItem = {
  action_verb?: string | null;
  coverage_id?: string | null;
  coverage_kind?: string | null;
  duration_minutes?: number | null;
  eligibility_snapshot_id?: string | null;
  encounter_type?: string | null;
  is_self_pay?: boolean;
  is_silenced?: boolean;
  last_verified_at?: string | null;
  lock_expires_at?: string | null;
  lock_set_by?: string | null;
  lock_set_by_name?: string | null;
  member_id_last4?: string | null;
  member_obligation_cents?: number | null;
  next_appointment_at?: string | null;
  next_appointment_id?: string | null;
  next_encounter_id?: string | null;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost)
      )
    | null;
  patient_id: string;
  patient_name: string;
  payer_name?: string | null;
  provider_license_level?: string | null;
  provider_name?: string | null;
  readiness?:
    | ("verified" | "collect" | "collected" | "attention" | "blocked" | "info")
    | null;
  readiness_label?: string | null;
  silenced_at?: string | null;
  silenced_until?: string | null;
  summary: string;
  task_priority: number;
  verification_method?: string | null;
};
export type SegmentCount = {
  /** Number of items in this segment */
  count: number;
  /** Segment key */
  key: string;
  /** Display label */
  label: string;
  /** Color hint: error, warning, success, or null */
  severity?: string | null;
};
export type WorklistTotals = {
  awaiting_check?: number;
  needs_attention?: number;
  needs_coverage?: number;
  self_pay?: number;
  silenced?: number;
  total_patients_in_window?: number;
  verified?: number;
};
export type WorklistWindow = {
  end: string;
  start: string;
};
export type WorklistResponse = {
  items?: WorklistItem[];
  page?: number;
  per_page?: number;
  segments?: SegmentCount[];
  total?: number;
  total_pages?: number;
  totals: WorklistTotals;
  window: WorklistWindow;
};
export type AlertDetail = {
  code: string;
  description: string;
  severity: "info" | "warning" | "error";
  suggested_action?: string | null;
  title: string;
};
export type BillingInput = {
  last_payment_date?: string | null;
  patient_due_status: string;
  total_charge_cents: number;
  total_paid_cents: number;
};
export type EligibilityBenefits = {
  coinsurance_percent?: number | null;
  copayment_cents?: number | null;
  deductible_cents?: number | null;
  oop_max_cents?: number | null;
  remaining_deductible_cents?: number | null;
  remaining_oop_max_cents?: number | null;
};
export type EligibilityCapabilities = {
  copay_decisions?: boolean;
  manual_entry?: boolean;
  payer_evidence?: boolean;
  records?: boolean;
};
export type FixedCopayCollection2 = {
  amount_cents: number;
  kind: "fixed_copay";
};
export type PatientCostSource2 = {
  confirmed_at: string;
  id: string;
  kind: "visit_amount_confirmation" | "final_claim_pr";
  revision: string;
};
export type PatientCostVisitContext2 = {
  appointment_id?: string | null;
  coverage_id: string;
  encounter_id?: string | null;
  service_date: string;
};
export type ConfirmedPatientCost2 = {
  amount_cents: number;
  amount_status?: "confirmed";
  coinsurance_percent?: number | null;
  collection?: FixedCopayCollection2 | null;
  copayment_cents?: number | null;
  coverage_id: string;
  policy_version?: "fixed-copay-v2";
  record_revision?: number | null;
  source: PatientCostSource2;
  visit_context: PatientCostVisitContext2;
};
export type UndeterminedPatientCost2 = {
  amount_cents?: null;
  amount_status?: "undetermined";
  coinsurance_percent?: number | null;
  collection?: FixedCopayCollection2 | null;
  copayment_cents?: number | null;
  coverage_id?: string | null;
  policy_version?: "fixed-copay-v2";
  reason:
    | "coinsurance_requires_allowed_amount"
    | "mixed_cost_sharing"
    | "deductible_applies"
    | "benefits_incomplete"
    | "visit_context_missing"
    | "source_unavailable";
  record_revision?: number | null;
  source?: null;
  visit_context?: PatientCostVisitContext2 | null;
};
export type EligibilityActorIdentity = {
  id: string;
  kind: "user" | "staff" | "agent" | "system" | "patient";
};
export type EligibilityActor = {
  id: string;
  kind: "user" | "staff" | "agent" | "system" | "patient";
  on_behalf_of?: EligibilityActorIdentity | null;
};
export type EligibilityFieldProvenance = {
  actor?: EligibilityActor | null;
  change_id?: string | null;
  evidence_id?: string | null;
  kind:
    | "automatic"
    | "manual"
    | "accept_copay"
    | "keep_current"
    | "legacy_initialize";
  legacy_basis?: ("explicit_manual" | "automatic" | "unresolved") | null;
  method?: ("phone" | "portal") | null;
  notes?: string | null;
  observed_at?: string | null;
  reference_number?: string | null;
  representative_name?: string | null;
  snapshot_id?: string | null;
};
export type EligibilityEmptyProjection = {
  baseline_token: string;
  benefits?: EligibilityBenefits;
  capabilities?: EligibilityCapabilities;
  coverage_checked_at?: string | null;
  coverage_result?: "active" | "inactive" | "unknown";
  organization_id: string;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost2)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost2)
      )
    | null;
  patient_id: string;
  patient_insurance_coverage_id: string;
  provenance?: {
    [key: string]: EligibilityFieldProvenance;
  };
  record_id?: null;
  revision?: null;
  state?: "empty";
};
export type EligibilityLegacyProjection = {
  baseline_token: string;
  benefits?: EligibilityBenefits;
  capabilities?: EligibilityCapabilities;
  coverage_checked_at?: string | null;
  coverage_result?: "active" | "inactive" | "unknown";
  organization_id: string;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost2)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost2)
      )
    | null;
  patient_id: string;
  patient_insurance_coverage_id: string;
  provenance?: {
    [key: string]: EligibilityFieldProvenance;
  };
  record_id?: null;
  revision?: null;
  state?: "legacy";
};
export type EligibilityRecordProjection = {
  baseline_token?: null;
  benefits?: EligibilityBenefits;
  capabilities?: EligibilityCapabilities;
  coverage_checked_at?: string | null;
  coverage_result?: "active" | "inactive" | "unknown";
  organization_id: string;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost2)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost2)
      )
    | null;
  patient_id: string;
  patient_insurance_coverage_id: string;
  provenance?: {
    [key: string]: EligibilityFieldProvenance;
  };
  record_id: string;
  revision: number;
  state?: "record";
};
export type VisitCoverageGap = {
  /** Last day of the gap; null = no later coverage on file */
  end?: string | null;
  /** First day of the gap window */
  start: string;
  /** The date of service evaluated */
  visit_date: string;
};
export type VisitLimitWarning = {
  plan_name: string;
  reason: "managed_medicaid" | "marketplace" | "pattern_match";
};
export type EligibilityCheckResponse = {
  alert_details?: AlertDetail[];
  alerts?: string[];
  billing?: BillingInput | null;
  corrected_member_id?: string | null;
  coverage_status: string;
  eligibility_check_state?: "not_applicable" | "current" | "due";
  eligibility_record?:
    | (
        | ({
            state: "empty";
          } & EligibilityEmptyProjection)
        | ({
            state: "legacy";
          } & EligibilityLegacyProjection)
        | ({
            state: "record";
          } & EligibilityRecordProjection)
      )
    | null;
  eligibility_snapshot_id?: string | null;
  encounter_id?: string | null;
  expires_at?: string | null;
  financials?: {
    [key: string]: any;
  };
  has_coverage?: boolean;
  is_self_pay?: boolean;
  is_silenced?: boolean;
  last_checked_at?: string | null;
  lock_expires_at?: string | null;
  lock_set_by?: string | null;
  lock_set_by_name?: string | null;
  next_action?: string;
  next_action_owner?: string;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost2)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost2)
      )
    | null;
  patient_id: string;
  patient_insurance_coverage_id?: string | null;
  payer_name?: string | null;
  pinned_appointment_at?: string | null;
  pinned_appointment_id?: string | null;
  pinned_encounter_id?: string | null;
  plan_status?: string | null;
  readiness?:
    | ("verified" | "collect" | "collected" | "attention" | "blocked" | "info")
    | null;
  readiness_label?: string | null;
  service_tier?: string;
  silenced_at?: string | null;
  silenced_until?: string | null;
  source?: string;
  status: string;
  submitted_member_id?: string | null;
  summary: string;
  verification_contacted_at?: string | null;
  verification_method?: string | null;
  verification_reference_number?: string | null;
  verification_rep_name?: string | null;
  visit_coverage_gap?: VisitCoverageGap | null;
  visit_limit_warning?: VisitLimitWarning | null;
};
export type EligibilityWritePrecondition = {
  baseline_token?: string | null;
  expected_revision?: number | null;
  idempotency_key: string;
};
export type ManualUpdateRequest = {
  coverage_status?: ("active" | "inactive" | "unknown") | null;
  /** Financial field overrides (e.g. copayment_cents, deductible_cents). Only include fields being asserted; an explicit null clears the stored benefit value. Coinsurance uses percentage units (20 means 20%). Valid fixed co-pay may supply a collection amount. Calculated obligations are ignored and cannot establish a visit total. */
  financials?: {
    [key: string]: any;
  } | null;
  method?: ("phone" | "portal") | null;
  /** Next action (none/portal_review/phone_verify/block) */
  next_action?: string | null;
  /** Next action owner (provider/biller/system) */
  next_action_owner?: string | null;
  /** Additional notes */
  notes?: string | null;
  patient_insurance_coverage_id?: string | null;
  precondition?: EligibilityWritePrecondition | null;
  /** Reason for the manual override */
  reason?: string | null;
  /** New status (eligible/needs_review/blocked) */
  status?: string | null;
  /** Updated summary text */
  summary?: string | null;
  /** When the call/portal action happened. May predate this request if the user is logging the verification after the fact. */
  verification_contacted_at?: string | null;
  /** Call/ticket reference number from the payer */
  verification_reference_number?: string | null;
  /** Payer rep name from the verification call */
  verification_rep_name?: string | null;
};
export type EligibilityBenefits2 = {
  coinsurance_percent?: number | null;
  copayment_cents?: number | null;
  deductible_cents?: number | null;
  oop_max_cents?: number | null;
  remaining_deductible_cents?: number | null;
  remaining_oop_max_cents?: number | null;
};
export type EligibilityCapabilities2 = {
  copay_decisions?: boolean;
  manual_entry?: boolean;
  payer_evidence?: boolean;
  records?: boolean;
};
export type FixedCopayCollection3 = {
  amount_cents: number;
  kind: "fixed_copay";
};
export type PatientCostSource3 = {
  confirmed_at: string;
  id: string;
  kind: "visit_amount_confirmation" | "final_claim_pr";
  revision: string;
};
export type PatientCostVisitContext3 = {
  appointment_id?: string | null;
  coverage_id: string;
  encounter_id?: string | null;
  service_date: string;
};
export type ConfirmedPatientCost3 = {
  amount_cents: number;
  amount_status?: "confirmed";
  coinsurance_percent?: number | null;
  collection?: FixedCopayCollection3 | null;
  copayment_cents?: number | null;
  coverage_id: string;
  policy_version?: "fixed-copay-v2";
  record_revision?: number | null;
  source: PatientCostSource3;
  visit_context: PatientCostVisitContext3;
};
export type UndeterminedPatientCost3 = {
  amount_cents?: null;
  amount_status?: "undetermined";
  coinsurance_percent?: number | null;
  collection?: FixedCopayCollection3 | null;
  copayment_cents?: number | null;
  coverage_id?: string | null;
  policy_version?: "fixed-copay-v2";
  reason:
    | "coinsurance_requires_allowed_amount"
    | "mixed_cost_sharing"
    | "deductible_applies"
    | "benefits_incomplete"
    | "visit_context_missing"
    | "source_unavailable";
  record_revision?: number | null;
  source?: null;
  visit_context?: PatientCostVisitContext3 | null;
};
export type EligibilityActorIdentity2 = {
  id: string;
  kind: "user" | "staff" | "agent" | "system" | "patient";
};
export type EligibilityActor2 = {
  id: string;
  kind: "user" | "staff" | "agent" | "system" | "patient";
  on_behalf_of?: EligibilityActorIdentity2 | null;
};
export type EligibilityFieldProvenance2 = {
  actor?: EligibilityActor2 | null;
  change_id?: string | null;
  evidence_id?: string | null;
  kind:
    | "automatic"
    | "manual"
    | "accept_copay"
    | "keep_current"
    | "legacy_initialize";
  legacy_basis?: ("explicit_manual" | "automatic" | "unresolved") | null;
  method?: ("phone" | "portal") | null;
  notes?: string | null;
  observed_at?: string | null;
  reference_number?: string | null;
  representative_name?: string | null;
  snapshot_id?: string | null;
};
export type EligibilityEmptyProjection2 = {
  baseline_token: string;
  benefits?: EligibilityBenefits2;
  capabilities?: EligibilityCapabilities2;
  coverage_checked_at?: string | null;
  coverage_result?: "active" | "inactive" | "unknown";
  organization_id: string;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost3)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost3)
      )
    | null;
  patient_id: string;
  patient_insurance_coverage_id: string;
  provenance?: {
    [key: string]: EligibilityFieldProvenance2;
  };
  record_id?: null;
  revision?: null;
  state?: "empty";
};
export type EligibilityLegacyProjection2 = {
  baseline_token: string;
  benefits?: EligibilityBenefits2;
  capabilities?: EligibilityCapabilities2;
  coverage_checked_at?: string | null;
  coverage_result?: "active" | "inactive" | "unknown";
  organization_id: string;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost3)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost3)
      )
    | null;
  patient_id: string;
  patient_insurance_coverage_id: string;
  provenance?: {
    [key: string]: EligibilityFieldProvenance2;
  };
  record_id?: null;
  revision?: null;
  state?: "legacy";
};
export type EligibilityRecordProjection2 = {
  baseline_token?: null;
  benefits?: EligibilityBenefits2;
  capabilities?: EligibilityCapabilities2;
  coverage_checked_at?: string | null;
  coverage_result?: "active" | "inactive" | "unknown";
  organization_id: string;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost3)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost3)
      )
    | null;
  patient_id: string;
  patient_insurance_coverage_id: string;
  provenance?: {
    [key: string]: EligibilityFieldProvenance2;
  };
  record_id: string;
  revision: number;
  state?: "record";
};
export type EligibilityCurrentResponse =
  | ({
      state: "empty";
    } & EligibilityEmptyProjection2)
  | ({
      state: "legacy";
    } & EligibilityLegacyProjection2)
  | ({
      state: "record";
    } & EligibilityRecordProjection2);
export type EligibilityBenefits3 = {
  coinsurance_percent?: number | null;
  copayment_cents?: number | null;
  deductible_cents?: number | null;
  oop_max_cents?: number | null;
  remaining_deductible_cents?: number | null;
  remaining_oop_max_cents?: number | null;
};
export type EligibilityCapabilities3 = {
  copay_decisions?: boolean;
  manual_entry?: boolean;
  payer_evidence?: boolean;
  records?: boolean;
};
export type FixedCopayCollection4 = {
  amount_cents: number;
  kind: "fixed_copay";
};
export type PatientCostSource4 = {
  confirmed_at: string;
  id: string;
  kind: "visit_amount_confirmation" | "final_claim_pr";
  revision: string;
};
export type PatientCostVisitContext4 = {
  appointment_id?: string | null;
  coverage_id: string;
  encounter_id?: string | null;
  service_date: string;
};
export type ConfirmedPatientCost4 = {
  amount_cents: number;
  amount_status?: "confirmed";
  coinsurance_percent?: number | null;
  collection?: FixedCopayCollection4 | null;
  copayment_cents?: number | null;
  coverage_id: string;
  policy_version?: "fixed-copay-v2";
  record_revision?: number | null;
  source: PatientCostSource4;
  visit_context: PatientCostVisitContext4;
};
export type UndeterminedPatientCost4 = {
  amount_cents?: null;
  amount_status?: "undetermined";
  coinsurance_percent?: number | null;
  collection?: FixedCopayCollection4 | null;
  copayment_cents?: number | null;
  coverage_id?: string | null;
  policy_version?: "fixed-copay-v2";
  reason:
    | "coinsurance_requires_allowed_amount"
    | "mixed_cost_sharing"
    | "deductible_applies"
    | "benefits_incomplete"
    | "visit_context_missing"
    | "source_unavailable";
  record_revision?: number | null;
  source?: null;
  visit_context?: PatientCostVisitContext4 | null;
};
export type EligibilityActorIdentity3 = {
  id: string;
  kind: "user" | "staff" | "agent" | "system" | "patient";
};
export type EligibilityActor3 = {
  id: string;
  kind: "user" | "staff" | "agent" | "system" | "patient";
  on_behalf_of?: EligibilityActorIdentity3 | null;
};
export type EligibilityFieldProvenance3 = {
  actor?: EligibilityActor3 | null;
  change_id?: string | null;
  evidence_id?: string | null;
  kind:
    | "automatic"
    | "manual"
    | "accept_copay"
    | "keep_current"
    | "legacy_initialize";
  legacy_basis?: ("explicit_manual" | "automatic" | "unresolved") | null;
  method?: ("phone" | "portal") | null;
  notes?: string | null;
  observed_at?: string | null;
  reference_number?: string | null;
  representative_name?: string | null;
  snapshot_id?: string | null;
};
export type EligibilityEmptyProjection3 = {
  baseline_token: string;
  benefits?: EligibilityBenefits3;
  capabilities?: EligibilityCapabilities3;
  coverage_checked_at?: string | null;
  coverage_result?: "active" | "inactive" | "unknown";
  organization_id: string;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost4)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost4)
      )
    | null;
  patient_id: string;
  patient_insurance_coverage_id: string;
  provenance?: {
    [key: string]: EligibilityFieldProvenance3;
  };
  record_id?: null;
  revision?: null;
  state?: "empty";
};
export type EligibilityLegacyProjection3 = {
  baseline_token: string;
  benefits?: EligibilityBenefits3;
  capabilities?: EligibilityCapabilities3;
  coverage_checked_at?: string | null;
  coverage_result?: "active" | "inactive" | "unknown";
  organization_id: string;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost4)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost4)
      )
    | null;
  patient_id: string;
  patient_insurance_coverage_id: string;
  provenance?: {
    [key: string]: EligibilityFieldProvenance3;
  };
  record_id?: null;
  revision?: null;
  state?: "legacy";
};
export type EligibilityRecordProjection3 = {
  baseline_token?: null;
  benefits?: EligibilityBenefits3;
  capabilities?: EligibilityCapabilities3;
  coverage_checked_at?: string | null;
  coverage_result?: "active" | "inactive" | "unknown";
  organization_id: string;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost4)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost4)
      )
    | null;
  patient_id: string;
  patient_insurance_coverage_id: string;
  provenance?: {
    [key: string]: EligibilityFieldProvenance3;
  };
  record_id: string;
  revision: number;
  state?: "record";
};
export type EligibilityCommandResponse = {
  change_id: string;
  current:
    | ({
        state: "empty";
      } & EligibilityEmptyProjection3)
    | ({
        state: "legacy";
      } & EligibilityLegacyProjection3)
    | ({
        state: "record";
      } & EligibilityRecordProjection3);
  observation_id: string;
  status: "applied" | "replayed";
};
export type EligibilityBenefits4 = {
  coinsurance_percent?: number | null;
  copayment_cents?: number | null;
  deductible_cents?: number | null;
  oop_max_cents?: number | null;
  remaining_deductible_cents?: number | null;
  remaining_oop_max_cents?: number | null;
};
export type EligibilityCapabilities4 = {
  copay_decisions?: boolean;
  manual_entry?: boolean;
  payer_evidence?: boolean;
  records?: boolean;
};
export type FixedCopayCollection5 = {
  amount_cents: number;
  kind: "fixed_copay";
};
export type PatientCostSource5 = {
  confirmed_at: string;
  id: string;
  kind: "visit_amount_confirmation" | "final_claim_pr";
  revision: string;
};
export type PatientCostVisitContext5 = {
  appointment_id?: string | null;
  coverage_id: string;
  encounter_id?: string | null;
  service_date: string;
};
export type ConfirmedPatientCost5 = {
  amount_cents: number;
  amount_status?: "confirmed";
  coinsurance_percent?: number | null;
  collection?: FixedCopayCollection5 | null;
  copayment_cents?: number | null;
  coverage_id: string;
  policy_version?: "fixed-copay-v2";
  record_revision?: number | null;
  source: PatientCostSource5;
  visit_context: PatientCostVisitContext5;
};
export type UndeterminedPatientCost5 = {
  amount_cents?: null;
  amount_status?: "undetermined";
  coinsurance_percent?: number | null;
  collection?: FixedCopayCollection5 | null;
  copayment_cents?: number | null;
  coverage_id?: string | null;
  policy_version?: "fixed-copay-v2";
  reason:
    | "coinsurance_requires_allowed_amount"
    | "mixed_cost_sharing"
    | "deductible_applies"
    | "benefits_incomplete"
    | "visit_context_missing"
    | "source_unavailable";
  record_revision?: number | null;
  source?: null;
  visit_context?: PatientCostVisitContext5 | null;
};
export type EligibilityActorIdentity4 = {
  id: string;
  kind: "user" | "staff" | "agent" | "system" | "patient";
};
export type EligibilityActor4 = {
  id: string;
  kind: "user" | "staff" | "agent" | "system" | "patient";
  on_behalf_of?: EligibilityActorIdentity4 | null;
};
export type EligibilityFieldProvenance4 = {
  actor?: EligibilityActor4 | null;
  change_id?: string | null;
  evidence_id?: string | null;
  kind:
    | "automatic"
    | "manual"
    | "accept_copay"
    | "keep_current"
    | "legacy_initialize";
  legacy_basis?: ("explicit_manual" | "automatic" | "unresolved") | null;
  method?: ("phone" | "portal") | null;
  notes?: string | null;
  observed_at?: string | null;
  reference_number?: string | null;
  representative_name?: string | null;
  snapshot_id?: string | null;
};
export type EligibilityEmptyProjection4 = {
  baseline_token: string;
  benefits?: EligibilityBenefits4;
  capabilities?: EligibilityCapabilities4;
  coverage_checked_at?: string | null;
  coverage_result?: "active" | "inactive" | "unknown";
  organization_id: string;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost5)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost5)
      )
    | null;
  patient_id: string;
  patient_insurance_coverage_id: string;
  provenance?: {
    [key: string]: EligibilityFieldProvenance4;
  };
  record_id?: null;
  revision?: null;
  state?: "empty";
};
export type EligibilityLegacyProjection4 = {
  baseline_token: string;
  benefits?: EligibilityBenefits4;
  capabilities?: EligibilityCapabilities4;
  coverage_checked_at?: string | null;
  coverage_result?: "active" | "inactive" | "unknown";
  organization_id: string;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost5)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost5)
      )
    | null;
  patient_id: string;
  patient_insurance_coverage_id: string;
  provenance?: {
    [key: string]: EligibilityFieldProvenance4;
  };
  record_id?: null;
  revision?: null;
  state?: "legacy";
};
export type EligibilityRecordProjection4 = {
  baseline_token?: null;
  benefits?: EligibilityBenefits4;
  capabilities?: EligibilityCapabilities4;
  coverage_checked_at?: string | null;
  coverage_result?: "active" | "inactive" | "unknown";
  organization_id: string;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost5)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost5)
      )
    | null;
  patient_id: string;
  patient_insurance_coverage_id: string;
  provenance?: {
    [key: string]: EligibilityFieldProvenance4;
  };
  record_id: string;
  revision: number;
  state?: "record";
};
export type EligibilityStaleStateResponse = {
  current:
    | ({
        state: "empty";
      } & EligibilityEmptyProjection4)
    | ({
        state: "legacy";
      } & EligibilityLegacyProjection4)
    | ({
        state: "record";
      } & EligibilityRecordProjection4);
  error?: "eligibility_stale_state";
};
export type EligibilityCommandConflict = {
  error: "eligibility_idempotency_conflict" | "eligibility_command_in_progress";
};
export type EligibilityCheckFailure = {
  error: "eligibility_check_failed" | "eligibility_check_outcome_uncertain";
};
export type EligibilityMemberIdMissing = {
  error: "eligibility_member_id_missing";
};
export type EligibilityWriteErrorResponse =
  | EligibilityStaleStateResponse
  | EligibilityCommandConflict
  | EligibilityCheckFailure
  | EligibilityMemberIdMissing;
export type EligibilityCheckRequest = {
  baseline_token?: string | null;
  expected_revision?: number | null;
  idempotency_key: string;
};
export type EligibilityAssertionPatch = {
  coinsurance_percent?: number | null;
  copayment_cents?: number | null;
  coverage_result?: ("active" | "inactive" | "unknown") | null;
  deductible_cents?: number | null;
  oop_max_cents?: number | null;
  remaining_deductible_cents?: number | null;
  remaining_oop_max_cents?: number | null;
};
export type EligibilityActorIdentity5 = {
  id: string;
  kind: "user" | "staff" | "agent" | "system" | "patient";
};
export type EligibilityActor5 = {
  id: string;
  kind: "user" | "staff" | "agent" | "system" | "patient";
  on_behalf_of?: EligibilityActorIdentity5 | null;
};
export type EligibilityFieldProvenance5 = {
  actor?: EligibilityActor5 | null;
  change_id?: string | null;
  evidence_id?: string | null;
  kind:
    | "automatic"
    | "manual"
    | "accept_copay"
    | "keep_current"
    | "legacy_initialize";
  legacy_basis?: ("explicit_manual" | "automatic" | "unresolved") | null;
  method?: ("phone" | "portal") | null;
  notes?: string | null;
  observed_at?: string | null;
  reference_number?: string | null;
  representative_name?: string | null;
  snapshot_id?: string | null;
};
export type EligibilityHistoryEntry = {
  asserted_fields: (
    | "coverage_result"
    | "copayment_cents"
    | "coinsurance_percent"
    | "deductible_cents"
    | "remaining_deductible_cents"
    | "oop_max_cents"
    | "remaining_oop_max_cents"
  )[];
  change_id: string | null;
  differences?: {
    [key: string]: "human_owned" | "unresolved_legacy";
  };
  from_revision: number | null;
  kind: "manual" | "automatic" | "legacy_initialize";
  observation_id: string;
  observed_values: EligibilityAssertionPatch;
  provenance: EligibilityFieldProvenance5;
  recorded_at: string;
  to_revision: number | null;
};
export type EligibilityHistoryResponse = {
  items: EligibilityHistoryEntry[];
};
export type EligibilityBenefits5 = {
  coinsurance_percent?: number | null;
  copayment_cents?: number | null;
  deductible_cents?: number | null;
  oop_max_cents?: number | null;
  remaining_deductible_cents?: number | null;
  remaining_oop_max_cents?: number | null;
};
export type EligibilityManualRequest = {
  baseline_token?: string | null;
  benefits?: EligibilityBenefits5;
  contacted_at: string;
  coverage_result: "active" | "inactive" | "unknown";
  expected_revision?: number | null;
  idempotency_key: string;
  method: "phone" | "portal";
  notes?: string | null;
  reference_number?: string | null;
  representative_name?: string | null;
};
export type SubmittedPolicyLabel = {
  payer_name?: string | null;
  plan_name?: string | null;
};
export type PayerHistoryItem = {
  claim_id: string;
  coinsurance_cents?: number | null;
  copay_cents?: number | null;
  deductible_cents?: number | null;
  lifecycle_reasons?: (
    | "no_adjudication"
    | "multiple_adjudications"
    | "source_limit"
    | "line_limit"
    | "malformed_amount"
    | "missing_source"
    | "unknown_status"
    | "correction"
    | "superseded"
    | "reversal"
    | "secondary_pending"
    | "missing_correction_link"
    | "missing_service_date"
    | "duplicate_source"
    | "ambiguous_components"
    | "secondary_forwarded"
    | "malformed_date"
  )[];
  lifecycle_status:
    | "reported"
    | "corrected"
    | "superseded"
    | "reversed"
    | "pending_secondary"
    | "unresolved";
  patient_insurance_coverage_id: string;
  payer_identifier?: string | null;
  payer_name?: string | null;
  recorded_at?: string | null;
  remittance_claim_id?: string | null;
  remittance_id?: string | null;
  reported_responsibility_cents?: number | null;
  service_date_from?: string | null;
  service_date_to?: string | null;
  source_date?: string | null;
  source_kind?: string | null;
  submitted_policy: SubmittedPolicyLabel;
};
export type PayerHistoryResponse = {
  attribution_scope?: "exact_policy_only";
  items: PayerHistoryItem[];
  truncated: boolean;
};
export type SnoozeAlertsRequest = {
  /** Datetime at which the snooze expires. Must be in the future and include a timezone offset — naive datetimes are rejected at validation so the service-layer comparison can't TypeError. */
  snooze_until: string;
};
export type FixedCopayCollection6 = {
  amount_cents: number;
  kind: "fixed_copay";
};
export type PatientCostSource6 = {
  confirmed_at: string;
  id: string;
  kind: "visit_amount_confirmation" | "final_claim_pr";
  revision: string;
};
export type PatientCostVisitContext6 = {
  appointment_id?: string | null;
  coverage_id: string;
  encounter_id?: string | null;
  service_date: string;
};
export type ConfirmedPatientCost6 = {
  amount_cents: number;
  amount_status?: "confirmed";
  coinsurance_percent?: number | null;
  collection?: FixedCopayCollection6 | null;
  copayment_cents?: number | null;
  coverage_id: string;
  policy_version?: "fixed-copay-v2";
  record_revision?: number | null;
  source: PatientCostSource6;
  visit_context: PatientCostVisitContext6;
};
export type UndeterminedPatientCost6 = {
  amount_cents?: null;
  amount_status?: "undetermined";
  coinsurance_percent?: number | null;
  collection?: FixedCopayCollection6 | null;
  copayment_cents?: number | null;
  coverage_id?: string | null;
  policy_version?: "fixed-copay-v2";
  reason:
    | "coinsurance_requires_allowed_amount"
    | "mixed_cost_sharing"
    | "deductible_applies"
    | "benefits_incomplete"
    | "visit_context_missing"
    | "source_unavailable";
  record_revision?: number | null;
  source?: null;
  visit_context?: PatientCostVisitContext6 | null;
};
export type VerificationEventResponse = {
  changes?: {
    [key: string]: any;
  } | null;
  coverage_status: string;
  created_at?: string | null;
  eligibility_snapshot_id?: string | null;
  encounter_id?: string | null;
  financials?: {
    [key: string]: any;
  };
  notes?: string | null;
  patient_cost?:
    | (
        | ({
            amount_status: "confirmed";
          } & ConfirmedPatientCost6)
        | ({
            amount_status: "undetermined";
          } & UndeterminedPatientCost6)
      )
    | null;
  patient_id: string;
  patient_insurance_coverage_id?: string | null;
  reason?: string | null;
  status: string;
  summary: string;
  user_id?: string | null;
  user_name?: string | null;
  verification_contacted_at?: string | null;
  verification_method?: string | null;
  verification_reference_number?: string | null;
  verification_rep_name?: string | null;
};
export type ListResponseVerificationEventResponse = {
  items: VerificationEventResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
